export const features = [
  {
    title: "Morning Bakery",
    description: "Cakes, muffins, scones baked in-house",
    icon: "<ion-icon name=\"storefront-outline\"></ion-icon>"
  },
  {
    title: "Specialty Coffee",
    description: "Single-origin beans, expertly brewed",
    icon: "<ion-icon name=\"cafe-outline\"></ion-icon>"
  },
  {
    title: "Home Delivery",
    description: "Delivered fresh to your doorsteps",
    icon: "<ion-icon name=\"gift-outline\"></ion-icon>"
  },
  {
    title: "Pre-order",
    description: "Order ahead, ready in two days",
    icon: "<ion-icon name=\"receipt-outline\"></ion-icon>"
  }
];
